import {
  FluidBadgeConfig,
  FluidButtonConfig,
  FluidButtonType,
  FluidIconKey,
  FluidSize,
} from '@lmig/fluid-core';

import { FluidCard } from '../fluid-card';

// ================================================================ //
// -- Card Utility Functions

/**
 * Returns config object for Card's "action button", or undefined if
 * appropriate Prop(s) do not exist. Maps Card's deprecated "actionText"
 * & "actionIcon" Props to a FluidButtonConfig object (overridden by
 * new "actionButtonConfig" Prop) & sets appropriate Button & Icon config
 * defaults.
 */
export const getActionButtonConfig = (host: FluidCard): FluidButtonConfig => {
  if (!host.actionButtonConfig && !host.actionText && !host.actionIcon) return;

  const defaultIconAfter = {
    iconAfter: {
      key: FluidIconKey.EXTERNAL_LINK,
      size: FluidSize.EXTRA_SMALL,
      ...host.actionIcon,
    },
  };
  const defaultIconOnly = {
    icon: {
      size: FluidSize.SMALL,
      ...host.actionIcon,
    },
  };

  return {
    icon: undefined,
    iconBefore: undefined,
    iconAfter: undefined,
    // Map deprecated "actionText" Prop to "label" (will be undefined if not provided to host)
    label: host.actionText,
    // If "actionText" provided, add default Icon OR "actionIcon" config (if provided)
    ...(!!host.actionText && defaultIconAfter),
    // If "actionText" is NOT provided AND "actionIcon" IS provided, create Icon-Only Button with "actionIcon"
    ...(!host.actionText && !!host.actionIcon && defaultIconOnly),
    // Merge "actionButtonConfig" Prop here to override all deprecated Prop configurations
    ...host.actionButtonConfig,
    // Button type should ALWAYS be "ghost", so we merge here to override "actionButtonConfig"
    type: FluidButtonType.GHOST,
    removeMargin: true,
    theme: host.theme,
    overrideGlobalTheme: true,
  };
};

/**
 * Returns config object for Card's header Badge, or undefined if
 * appropriate Prop(s) do not exist. Maps Card's deprecated "isNew"
 * Prop (if it exists) to a FluidBadgeConfig object.
 */
export const getBadgeConfig = (host: FluidCard): FluidBadgeConfig => {
  if (!host.isNew && !host.badgeConfig) return;
  return {
    label: host.isNew ? 'New!' : undefined,
    ...host.badgeConfig,
    theme: host.theme,
    overrideGlobalTheme: true,
  };
};
